export const formatPropertyLocation = (response) => {
  const { location, locations_structure } = response;

  const city = locations_structure.find(
    (loc) => loc.administrative_level === "Comune"
  );
  const zone = locations_structure.find(
    (loc) => loc.administrative_level === "Zona"
  );

  const cityName = city ? city.name : null;
  const zoneName = zone ? zone.name : null;
  const addressName = location ? location.name : null;

  const parts = [cityName, zoneName, addressName].filter(Boolean);

  return parts.join(" • ");
};

export const formatExternalPropertyLocation = (location) => {
  if (!location || typeof location !== "string") return "";

  return location.replace(/([a-zA-Z])(?=[A-Z])/g, "$1 • ");
};
